<template>
	<div class="app flex-row align-items-center">
		<div v-if="authenticating" class="loader"></div>
		<div class="container" v-else>
			<b-row class="justify-content-center">
				<b-col md="8">
					<b-card-group>
						<b-card no-body class="p-4 loginCard">
							<b-card-body>
								<b-form>
									<h1>{{$t('login.title')}}</h1>
									<p class="text-muted">{{$t('login.account')}}</p>
									<b-input-group class="mb-3">
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-user"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input type="text" class="form-control" :placeholder="$t('users-l.username')"
													  ref="loginEmail"
													  v-model="userData.username"
													  v-on:keyup.enter="loginUser"
													  :state="isValidName"
													  />
									</b-input-group>
									<b-input-group class="mb-4">
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input type="password" class="form-control" :placeholder="$t('users-l.create.password')"
													  autocomplete="current-password" v-model="userData.password"
													  :state="isValidPass"
													  v-on:keyup.enter="loginUser"
														/>
									</b-input-group>
									<b-row>
										<b-col cols="6">
											<b-button variant="primary" class="px-4" @click="loginUser"
													  :disabled="disabled">
												{{$t('login.come-out')}}
											</b-button>
										</b-col>
										<!--<b-col cols="6" class="text-right">
											<b-button variant="link" class="px-0">Forgot password?</b-button>
										</b-col>-->
									</b-row>
								</b-form>
							</b-card-body>
						</b-card>
						<b-card no-body class="text-white py-5 d-md-down-none loginCard" style="width:44%">
							<b-card-body class="text-center d-flex justify-content-center align-items-center">
								<div>
									<img class="" src="../../../public/img/brand/dwpost.png" width="300"
										 alt="Logo">
									<h4 class="text-primary mt-4">{{$t('login.title-login')}}</h4>
									<h4 class="text-primary">{{$t('login.title-login2')}}</h4>
								</div>
							</b-card-body>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'
	export default {
		name: 'Login',
		data() {
			return {
				userData: {
					username: '',
					password: ''
				},
				disabled: false,
				loading: false,
			}
		},
		computed: {
			...mapGetters([
				'authenticating',
				'authenticationError',
				'authenticationErrorCode'
			]),
			isValidName() {
				return this.authenticationErrorCode === 0 ? null : false;
			},
			isValidPass() {
				return this.authenticationErrorCode === 0 ? null : false;
			}
		},
		methods: {
			...mapActions([
				'login'
			]),
			async loginUser() {
				// Perform a simple validation that username and password have been typed in
				if (this.userData.username != '' && this.userData.password != '') {
					await this.login(this.userData);
					this.userData.password = "";
				}
			}
		},
		mounted () {
			this.$refs.loginEmail.focus()
		},
	}
</script>

<style scoped>
	.loginCard {
		min-height: unset !important;
	}
	.loader {
		position: absolute;
		left: 44%;
		top: 40%;
		z-index: 1;
		border: 8px solid #f3f3f3;
		border-radius: 50%;
		border-top: 8px solid #0092D3;
		border-bottom: 8px solid #0092D3;
		width: 100px;
		height: 100px;
		-webkit-animation: spin 2s linear infinite;
		animation: spin 2s linear infinite;
	}

	@-webkit-keyframes spin {
		0% { -webkit-transform: rotate(0deg); }
		100% { -webkit-transform: rotate(360deg); }
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>
